var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c(
        "Title",
        { attrs: { strong: "", bold: "" } },
        [
          _vm.donationWay === _vm.donationWayType.ECPAY_PERIOD_CREDIT ||
          _vm.donationWay === _vm.donationWayType.LINEPAY_PERIOD
            ? [_vm._v(" " + _vm._s(_vm.steps.DONATION_PERIOD) + " ")]
            : [_vm._v(" " + _vm._s(_vm.steps.DONATION_SINGLE) + " ")],
        ],
        2
      ),
      _vm.donationWay === _vm.donationWayType.ECPAY_PERIOD_CREDIT ||
      _vm.donationWay === _vm.donationWayType.ECPAY_SINGLE_CREDIT
        ? [
            _vm.environment == "development" || _vm.environment == "staging"
              ? _c("span", [
                  _vm._v(" 現在是測試環境（" + _vm._s(_vm.environment) + "）"),
                  _c("br"),
                  _vm._v(" 綠界測試卡號：4311-9522-2222-2222 "),
                  _c("br"),
                  _vm._v(
                    " 有效期限：12/" +
                      _vm._s(
                        (new Date().getFullYear() + 1).toString().slice(-2)
                      ) +
                      " 安全碼 : 222 "
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.donationWay === _vm.donationWayType.LINEPAY_SINGLE ||
      _vm.donationWay === _vm.donationWayType.LINEPAY_PERIOD
        ? _c("div", [_vm._v(" 即將跳轉到 LINE Pay 頁面 ")])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }